import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const L2eMonthlyPointLogsActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

L2eMonthlyPointLogsActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

L2eMonthlyPointLogsActions.defaultProps = {
  basePath: '',
  data: {},
};

export default L2eMonthlyPointLogsActions;
